import React, { useEffect } from "react";
import { track, EVENTS } from "../../utils/analytics";

/**
 * Reusable promotion banner (Growth Platform — Slice S5).
 *
 * Renders ANY promotion record from the promotions engine. Preserves the
 * exact premium look of the original hard-coded Military banner, but is now
 * data-driven — the same component renders student, holiday, or member-only
 * promotions with no new markup.
 *
 * Emits `promotion_viewed` once on mount (spec §35).
 *
 * @param {Object} promo - a live promotion record (see promotionsData.js).
 */
function PromotionBanner({ promo }) {
  useEffect(() => {
    if (promo) {
      track(EVENTS.PROMOTION_VIEWED, {
        promotion_id: promo.id,
        eligibility: promo.eligibility,
      });
    }
  }, [promo]);

  if (!promo) return null;

  const tags = promo.badge?.tags || [];

  return (
    <div
      style={{
        marginTop: "50px",
        background:
          "linear-gradient(135deg, #1a365d 0%, #2c5282 50%, #1a365d 100%)",
        borderRadius: "16px",
        padding: "30px 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        flexWrap: "wrap",
        boxShadow: "0 10px 40px rgba(26, 54, 93, 0.3)",
        border: "2px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <div
          style={{
            width: "60px",
            height: "60px",
            background: "linear-gradient(135deg, #ffaa19 0%, #ff8c00 100%)",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 15px rgba(255, 170, 25, 0.4)",
            flexShrink: 0,
          }}
        >
          <i
            className={promo.badge?.icon || "fas fa-tag"}
            style={{ fontSize: "28px", color: "#1a365d" }}
          />
        </div>
        <div>
          <h4
            style={{
              color: "#ffffff",
              fontSize: "22px",
              fontWeight: "700",
              margin: "0 0 5px 0",
            }}
          >
            {promo.title}
          </h4>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.85)",
              fontSize: "15px",
              margin: 0,
            }}
          >
            {promo.description}
          </p>
        </div>
      </div>

      {tags.length > 0 && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {tags.map((t) => (
            <span
              key={t.label}
              style={{
                background: "rgba(255, 255, 255, 0.15)",
                color: "#ffffff",
                padding: "8px 16px",
                borderRadius: "20px",
                fontSize: "13px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <i className={t.icon} style={{ color: t.color || "#ffaa19" }} />
              {t.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default PromotionBanner;
